// ProjectItem Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import DateUtil from '../../../lib/dateutil.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import Util from '../../../lib/util.jsx'

import Avatar from '../../../common/common/avatar/avatar.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import ProgressCircle from '../../../common/graph/progress_circle/progress_circle.jsx'

class ProjectItem extends Component {
  static get propTypes () {
    return {
      project: PropTypes.object.isRequired,
      onSettings: PropTypes.func,
      onView: PropTypes.func,
      showProjectNumber: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      project: null,
      OnSettings: null,
      onView: null,
      showProjectNumber: false
    }
  }

  render () {
    const { project, showProjectNumber } = this.props
    const statusCls = project.status ? project.status.toLowerCase() : ''
    const _className = classnames('project-item', {}, statusCls)
    const projectStatus = Util.getTranslatedStatus(project.status)

    return (
      <div className={_className} title={project.title}>
        <div className='hovercontent'>
          <IconButton
            title='project.list.tipView'
            icon='common-action-setting'
            size='small'
            onClick={this._onSettings.bind(this)}
          />
        </div>
        <div className='item-details' onClick={this._onView.bind(this)}>
          <div className='header'>
            <h3 className='title'>{project.title}</h3>
            <span className='status'>
              <IntlMessage ident={projectStatus} />
            </span>
          </div>
          <div className='content'>
            {showProjectNumber && (
              <>
                <span className='projectnumber'>
                  {project.projectNumber || '-'}
                </span>
                <div className='splitter' />
              </>
            )}
            {project.contact ? (
              <span className='clientname'>{project.contact.company}</span>
            ) : null}
            {project.endDate ? <div className='splitter' /> : null}
            {this._renderDeadline()}
          </div>
          <ProgressCircle
            value={parseInt(project.percentageCompleted, 10)}
            formatOverdue
          />
          {project.contact && project.contact.imageUrl && (
            <Avatar imageUrl={project.contact.imageUrl} />
          )}
        </div>
      </div>
    )
  }

  /* Private Functions */
  _renderDeadline () {
    const project = this.props.project
    if (project.endDate) {
      const deadline = new Date(project.endDate)

      if (!project.completed) {
        // Check status is completed or not
        return (
          <div className='deadline'>{DateUtil.displayHumanized(deadline)}</div>
        )
      }

      return ''
    }

    return ''
  }

  _onView (e) {
    e.preventDefault()

    if (this.props.onView) {
      this.props.onView(this.props.project)
    }
  }

  _onSettings (e) {
    e.preventDefault()

    if (this.props.onSettings) {
      this.props.onSettings(this.props.project)
    }
  }
}

export default ProjectItem
